import styled, { css } from 'styled-components';

import { Box } from '@/components/Box';
import { Row as BasicRow } from '@/components/Row';

export const Wrapper = styled(Box)`
  ${({ theme }) => css`
    padding: ${theme.spacing(0, 2, 2, 2)};
    ${theme.media.md.up} {
      padding-left: ${theme.spacing(6)};
      padding: ${theme.spacing(0, 6, 6, 6)};
    }
  `}
`;

export const FormWrapper = styled(Box)`
  max-width: 500px;
  margin: 60px auto 0 auto;
`;

export const SectionHeaderWrapper = styled(Box)`
  height 150px;
  ${({ theme }) => css`
    background: ${theme.colors.lightGrey};
    padding-top: ${theme.spacing(8)};
    padding-bottom: ${theme.spacing(5)};
  `}
`;

export const Row = styled(BasicRow)`
  margin: 20px auto;

  ${({ theme }) => css`
    grid-gap: ${theme.spacing(2)};
  `}
`;

export const OrderStatusViewBodyContainer = styled(Box)`
  max-width: ${({ theme }) => theme.breakpoints.lg};
  margin-left: auto;
  margin-right: auto;
  margin-top: ${({ theme }) => theme.spacing(8)};
  padding: ${({ theme }) => theme.spacing(0, 4, 4, 4)};

  ${({ theme }) => css`
    ${theme.media.md.up} {
      padding: ${theme.spacing(0, 5, 4, 5)};
    }
  `}
`;
